import {
  CommonBadgeProps,
  NotificationBadgeLayout,
  NotificationBadgeLayoutType,
  NotificationBadgeSizeType,
} from '@/types';

import Icon from '@/components/common/iconedLinks/Icon';

import styles from './NotificationBadge.module.scss';

type NotificationBadgeProps = CommonBadgeProps & {
  size: NotificationBadgeSizeType;
  layout: NotificationBadgeLayoutType;
  icon?: { url: string; alt: string };
  label?: string;
};

export const NotificationBadge = ({
  size,
  layout,
  background,
  border,
  label,
  icon,
}: NotificationBadgeProps): React.JSX.Element => {
  const computedStyle = [
    styles.container,
    styles[size],
    styles[layout],
    background,
    border
  ].join(' ');

  return (
    <div className={computedStyle} data-test-id="notification-badge">
      {layout === NotificationBadgeLayout.LABEL && label && (
        <span data-test-id="label">{label}</span>
      )}
      {layout === NotificationBadgeLayout.ICON && icon && (
        <Icon src={icon.url} alt={icon.alt} />
      )}
    </div>
  );
};

export default NotificationBadge;
